import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["edition", "recipientType", "entry", "participantSelection", "recipientSummary", "empty"]

  connect() { this.update() }

  editionChanged() {
    this.entryTargets.forEach(entry => { entry.querySelector("input").checked = false })
    this.update()
  }

  update() {
    const all = this.recipientTypeTarget.value === "all_participants"
    const single = this.recipientTypeTarget.value === "single_participant"
    let available = 0
    let selected = 0
    this.entryTargets.forEach(entry => {
      const eligible = entry.dataset.editionId === this.editionTarget.value
      const checkbox = entry.querySelector("input")
      entry.hidden = !eligible
      checkbox.disabled = !eligible || all
      if (eligible) available += 1
      if (eligible && checkbox.checked) selected += 1
    })
    this.participantSelectionTarget.hidden = all
    this.emptyTarget.hidden = available > 0
    this.recipientSummaryTarget.textContent = all
      ? `${available} approved entries currently eligible. The audience is fixed when you publish. Each entry gets a private conversation.`
      : `${selected} ${selected === 1 ? "entry" : "entries"} selected.${single ? " Choose exactly one entry." : ""} Each entry gets a private conversation.`
  }
}
